const paletteConstants = {
  MAX_INPUT_COUNT: 8,
  DEFAULT_INPUT_COUNT: 4,
  DEFAULT_TRANSITION_LENGTH: 130,
  SPLICE_CORES: ['P', 'SC', 'SCP', 'SCS', 'SCSP', 'P3-SC', 'P3-SCP'],
};

export default paletteConstants;
